import { CARD_SHADOW_HOVER, PRIMARY } from "@app/theme/tokens";
import { Box, Paper, Typography } from "@mui/material";

export default function DashboardCard({
  title,
  action,
  children,
}: {
  title: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2.25,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow 180ms",
        "&:hover": { boxShadow: CARD_SHADOW_HOVER },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 1.5,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
          <Box
            sx={{
              width: 3,
              height: 18,
              borderRadius: 3,
              bgcolor: PRIMARY,
              flexShrink: 0,
            }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
        </Box>
        {action}
      </Box>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Paper>
  );
}
